export enum AppointmentAttendanceStatus {
  Attended = "ATTENDED",
  CancelledOrRescheduled = "CANCELLED_OR_RESCHEDULED",
  NoShow = "NO_SHOW",
  RescheduledByStaff = "RESCHEDULED_BY_STAFF",
}

export enum CaseNoteListFilter {
  All = "all",
  AppointmentNotesOnly = "appointmentNotesOnly",
}
